import React from 'react';
import { About, Footer, Header, Skills, Work } from './sections';
import { Navbar } from './components';
import './App-Styles/app.css';

const App = () => {
  return (
    <div className='app'>
      <Navbar />
      <Header />
      <Work />
      <Skills />
      {/* <Testimonial /> */}
      <About />
      <Footer />
    </div>
  );
};

export default App;
